// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1-lek","range":"MonthRangeSwitch_range__gAqc_","disabled":"MonthRangeSwitch_disabled__Tk6XC"};